// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"AssetOptionsMenu_checkboxes__1bdGg"};